"use client";

// src/skeleton.tsx
import { cn } from "@momo/utils";
import { jsx } from "react/jsx-runtime";
var Skeleton = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx("div", { className: cn("bg-muted animate-pulse rounded-md", className), ...rest });
};

export {
  Skeleton
};
